export default __webpack_public_path__ + "static/media/coming-soon.9e671d80.jpg";